import { LegalLayout } from "./LegalLayout";
import { BANK_TRANSFER, OPERATOR, PRICING } from "../../../shared/constants";

const yen = (n: number) => `${n.toLocaleString("ja-JP")}円`;

// 特定商取引法に基づく表記(税込総額のみ・免税事業者のため消費税区分なし)。
// 住所・責任者名等の未確定項目は運営で確定させること。
export function TokushohoPage() {
  return (
    <LegalLayout title="特定商取引法に基づく表記">
      <dl className="legal-dl">
        <dt>販売事業者</dt>
        <dd>{OPERATOR.companyName}</dd>

        <dt>運営統括責任者</dt>
        <dd>（記載予定）</dd>

        <dt>所在地</dt>
        <dd>請求があった場合、遅滞なく開示します。</dd>

        <dt>連絡先</dt>
        <dd>請求があった場合、遅滞なく開示します。</dd>

        <dt>販売価格</dt>
        <dd>
          初期費用 {yen(PRICING.initialFee)} / 月額管理費 {yen(PRICING.monthlyFee)} /
          AIクレジット {PRICING.creditChargeOptions.map((n) => yen(n)).join("・")}
          （すべて税込総額）。初回登録時に{yen(PRICING.initialCreditGrant)}分のAIクレジットを付与します。
        </dd>

        <dt>商品代金以外の必要料金</dt>
        <dd>銀行振込手数料はお客様のご負担となります。</dd>

        <dt>支払方法</dt>
        <dd>
          銀行振込のみ。{BANK_TRANSFER.bankName}（{BANK_TRANSFER.bankCode}）
          {BANK_TRANSFER.branchName}（{BANK_TRANSFER.branchCode}）
          {BANK_TRANSFER.accountType} {BANK_TRANSFER.accountNumber}
          名義 {BANK_TRANSFER.accountHolder}
        </dd>

        <dt>支払時期</dt>
        <dd>
          アカウント登録後、初期構築費用を銀行振込でお支払いいただきます。
          入金確認後にヒアリング・ページ設計・制作フローを開始します。
        </dd>

        <dt>役務の提供時期</dt>
        <dd>入金確認後、順次サイト制作・公開を行います。</dd>

        <dt>返品・キャンセル</dt>
        <dd>
          役務の性質上、制作着手後の返金はお受けできません。AIクレジットの有効期限は付与から
          {PRICING.creditExpiryMonths}ヶ月です。
        </dd>
      </dl>
    </LegalLayout>
  );
}
